import { SearchState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const defaultState: SearchState = {
  searchQuery: '',
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'SAVE_SEARCH_QUERY':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
